import { IntrinsicSizeImg } from 'components/Img';
import Link from 'components/Link';
import Text from 'components/Text';
import type { FieldKey } from 'hooks';
import type { TemplateString } from 'types';
import { cn } from 'utils/classNames';
import { formatDisplayUrl, formatTemplate } from 'utils/format';
import { is } from 'utils/helpers';

interface Props {
	className?: string;
	features?: string[];
	heading: string;
	logoAlt: string | undefined;
	logoSrc?: string;
	source?: string;
	sourceLinkLabel: string;
	sourceText: FieldKey | TemplateString;
	sourceUrl?: string;
}

export default function ProductDetailsExternalReview({
	className,
	features,
	heading,
	logoAlt,
	logoSrc,
	source,
	sourceLinkLabel,
	sourceText,
	sourceUrl,
}: Props) {
	return (
		<div className={cn('inline-block border border-strong p-6', className)}>
			<Text as="h2" text={heading} />
			<p className="mb-6">
				{formatTemplate(sourceText, {
					source,
				})}
			</p>
			{logoSrc && (
				<IntrinsicSizeImg
					alt={logoAlt}
					src={logoSrc}
					className="mb-6 max-h-16 w-auto max-w-40"
				/>
			)}
			{is.arrayWithLength(features) && (
				<ul className="mb-6 inline-flex list-inside list-disc flex-col gap-2 font-bold">
					{features.map((feature) => (
						<li key={feature}>{feature}</li>
					))}
				</ul>
			)}
			{sourceUrl && (
				<p>
					{`${sourceLinkLabel}: `}
					<Link
						underline
						className="break-all"
						target="_blank"
						href={sourceUrl}
					>
						{formatDisplayUrl(sourceUrl)}
					</Link>
				</p>
			)}
		</div>
	);
}

ProductDetailsExternalReview.displayName = 'ProductDetailsExternalReview';
